import { IntroHeader } from "../components/common/Header";


import {About as AboutUs} from "../components/About";
import Services from "../components/Services";
import { Portfolio } from "../components/Portfolio";
/* import Testimonials from "../components/Testimonials"; */
/* import Contact from "../components/Contact"; */
import AIChat from "../components/AIChat";


const LandingMain = () => {

    return (
        <>
            

      <IntroHeader 
        backgroundType="image"
        backgroundSrc="images/intro-bg.jpg"
        maskClass="opacity-8 bg-dark"
      />
                <div id="content" role="main" className="bg-light">
                <AboutUs></AboutUs>
                <Services></Services>
                <Portfolio></Portfolio>
{/*                 <Testimonials></Testimonials> */}
{/*                <Contact></Contact> */}
                <AIChat />
                 </div>

        </>
    )

};

export default LandingMain;